import { useListingCTAs } from '../../../../hooks/useListingCTAs';
import { Button } from '../../../ui/Button';
import { desktopCTAsContainer } from './desktopCTAs.styles';

export const DesktopCTAs = () => {
  const { ctas, overlays } = useListingCTAs();

  if (ctas.length === 0) return null;

  return (
    <div className={desktopCTAsContainer}>
      {ctas.map((cta) => (
        <Button
          key={cta.id}
          shape="rectangle"
          tone="brand"
          emphasis={cta.emphasis}
          icon={cta.icon}
          onClick={cta.onClick}
          aria-label={cta.ariaLabel}
        >
          {cta.label}
        </Button>
      ))}
      {overlays}
    </div>
  );
};
